import { render, staticRenderFns } from "./Yfb.vue?vue&type=template&id=2efb5645&scoped=true"
import script from "./Yfb.vue?vue&type=script&lang=js"
export * from "./Yfb.vue?vue&type=script&lang=js"
import style0 from "./Yfb.vue?vue&type=style&index=0&id=2efb5645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb5645",
  null
  
)

export default component.exports